(() => {
  function waitForWindowKey(key, callback, timeout = 5000) {
    const POLL_INTERVAL = 100;
    const startTime = Date.now();
  
    function checkWindowKey() {
      if (key in window) {
        callback();
      } else if (Date.now() - startTime < timeout) {
        setTimeout(checkWindowKey, POLL_INTERVAL);
      } else {
        console.warn('Key not found in window');
      } 
    }
  
    checkWindowKey();
  }

  waitForWindowKey('storeifyStorelocator', () => {

    if (location.pathname === '/a/store-locator/list') {
      const sectionHeader = document.querySelector('.bootstrap-storeifyapps .section-header');

      if (sectionHeader.querySelector('p').innerHTML === '&nbsp;') {
        sectionHeader.querySelector('p').remove();
      }
    } else if (location.pathname.startsWith('/a/store-locator/')) {
      // const title = document.querySelector('.header-store-name');
      // title.classList.add('visually-hidden');
      // document.querySelector('.store-info .title-store-info').innerHTML = title.innerText;

      document.querySelector('.store-info .title-store-info')?.remove();

      const elStoreDetailContent = document.querySelector('.store-detail-content');
      const elContentStoreInfo = document.querySelector('.content-store-info');

      if (elStoreDetailContent) {
        elStoreDetailContent.insertAdjacentHTML('afterbegin', `
          <h2 class="h3">${storeifyStorelocator.lang.about}</h2>
        `);
      }
      
      if (elStoreDetailContent && elContentStoreInfo) {
        const wrapperDiv = document.createElement('div');
        wrapperDiv.className = 'content-store-info-wrapper';
        elContentStoreInfo.parentNode.insertBefore(wrapperDiv, elContentStoreInfo);
        wrapperDiv.appendChild(elContentStoreInfo);
        wrapperDiv.appendChild(elStoreDetailContent);
      }

      const contactBtnWrapper = document.querySelector('.title-contactstore');
      if (contactBtnWrapper) {
        contactBtnWrapper.setAttribute('class', 'title-contactstore-wrapper');
      }

      const contactBtn = document.querySelector('#storeify-storeloctor-contactBnt');
      if (contactBtn) {
        contactBtn.setAttribute('class', 'button button--lg');
        contactBtn.setAttribute('href', "javascript:void(0)");
        // contactBtn.setAttribute('target', '_blank');
      }

      const address = document.querySelector('.storeify-sl-item-row.entry-item.entry-item-address');
      if (address) {
        address.insertAdjacentHTML(
          'afterbegin',
          `
          <span class="storeify_sl_button_svg">
            <svg width="17" height="21" viewBox="0 0 17 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16.2053 8.76405C16.2053 14.0138 8.91662 19.8369 8.91662 19.8369C8.91662 19.8369 1.62793 13.9904 1.62793 8.76405C1.62793 4.76962 4.89119 1.53149 8.91662 1.53149C12.942 1.53149 16.2053 4.76962 16.2053 8.76405Z" stroke="#3B3B3B" stroke-width="1.5"/>
              <ellipse cx="9.13201" cy="8.24085" rx="2.60564" ry="2.58557" stroke="#3B3B3B" stroke-width="1.5"/>
            </svg>
          </span>
        `,
        );
      }
    }
    
  });


})();